import axios from 'axios'
import { AnyAction, Dispatch } from 'redux'

import { broadcastSessionTermination } from '@lyrahealth-inc/shared-app-logic/src/features/common/hooks/useSessionSync'
import { clearStorageDataOnLogout } from '@lyrahealth-inc/shared-app-logic/src/features/common/utils/logoutUtils'
import { clearEventRegistrationIntent } from '@lyrahealth-inc/shared-app-logic/src/features/essentials/webEventRegistrationIntent'

import { APP_ID, APP_PLATFORM } from '../../common/constants/appConstants'
import { clearPendoSession } from '../../common/utils/pendoLoader'
import { updateStoredProviderResultsSurveyValues } from '../../common/utils/pendoUtils'
import mixpanel from '../../data/mixpanel/mixpanel-browser'
import { resetParsePreferenceData } from '../../features/onboard/carePreferences/data/carePreferencesActions'
import { appRouter_DO_NOT_USE as appRouter } from '../../features/routing/legacyRouterShim'

export const RESET_STORE = 'RESET_STORE'
export const SET_IS_SESSION_TIMED_OUT = 'SET_IS_SESSION_TIMED_OUT'
export const RESET_HEALTHPLAN = 'RESET_HEALTHPLAN'
export const RESET_TRIAGE = 'RESET_TRIAGE'
export const SET_IS_LOGOUT_IN_PROGRESS = 'SET_IS_LOGOUT_IN_PROGRESS'

export const resetStore = () => ({
  type: RESET_STORE,
})

export const resetHealthPlan = () => ({
  type: RESET_HEALTHPLAN,
})

export const resetTriage = () => ({
  type: RESET_TRIAGE,
})

export const setIsSessionTimedOut = (value: boolean) => ({
  type: SET_IS_SESSION_TIMED_OUT,
  value,
})

export const setIsLogoutInProgress = (value: boolean) => ({
  type: SET_IS_LOGOUT_IN_PROGRESS,
  value,
})

export const clearActiveSession = async (dispatch: Dispatch<AnyAction>) => {
  await clearEventRegistrationIntent()
  try {
    await axios.get('/logout?expired=true')
  } catch (error) {
    console.error(error)
  }
  mixpanel.reset()
  mixpanel.register({ app_platform: APP_PLATFORM, app_id: APP_ID })
  clearPendoSession()
  window.checksumai?.reset?.()
  updateStoredProviderResultsSurveyValues()
  clearStorageDataOnLogout()
  dispatch(resetParsePreferenceData())
  dispatch(resetStore())
  broadcastSessionTermination()
}

export const sessionExpiredLogout = () => {
  return (dispatch: Dispatch<AnyAction>) => {
    axios
      .get('/logout?expired=true')
      .catch((error) => {
        console.error(error)
      })
      .finally(async () => {
        await clearEventRegistrationIntent()
        mixpanel.reset()
        clearPendoSession()
        window.checksumai?.reset?.()
        updateStoredProviderResultsSurveyValues()
        clearStorageDataOnLogout()
        // Clear only parsePreferenceId to prevent it from leaking between users
        dispatch(resetParsePreferenceData())
        dispatch(resetStore())
        appRouter.navigate('/login')
      })
  }
}
